module.exports = __webpack_public_path__ + "static/media/Gt Dunmow Wardrobes (7).920d112d.jpg";